import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import moment from 'moment';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class PortalDailyDeliveredLogTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      play: false,
      isLoading:false,
      customers:[],
      selected_date:new Date(),
      selectedCustomers:[],
      getReportUrl:'/api/v1/portal/portal-admin/daily-delivered-car-report/',
      dailyDeliveredCarReportData:[],
      selected: [],
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
    };
    this.handleDeliveredDateCalendarChange = this.handleDeliveredDateCalendarChange.bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    this.handleDailyDeliveredCarReportGeneration = this.handleDailyDeliveredCarReportGeneration.bind(this);
  }
  componentDidMount() {
    let options = [];   
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
          response.map((customer)=>{
            options.push({
                label : customer.company.short_name+'-'+customer.name,
                value : customer.id
            });
        });
        this.setState({
          customers: options,
          isLoading: false
        });
      });
    });
  }
  handleDeliveredDateCalendarChange(date) {
    this.setState({
      selected_date: date
    });
  }
  handleCustomerSelection(selectedCustomers) {
    this.setState({selectedCustomers});
  }
  handleDailyDeliveredCarReportGeneration(e){
      this.setState({
        isLoading: true
      })
      let dailyDeliveredLogData = {};
      dailyDeliveredLogData.selected_date = moment(this.state.selected_date).format("YYYY-MM-DD");
      dailyDeliveredLogData.selected_customer = this.state.selectedCustomers;
      
      let url = this.state.getReportUrl+dailyDeliveredLogData.selected_date;
      
      return fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
        body: JSON.stringify({
          customer_ids: dailyDeliveredLogData.selected_customer
        }),
      }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            dailyDeliveredCarReportData: response,
            isLoading: false
          })
        });
      });
  }
  download(filename, text) {
    let reportData = "";
    $('.daily-delivered-report-tbl tr').each(function() {
        $(this).find('td').each(function() {
            reportData = reportData + ($(this).text().replace(',',''))+',';
        });
        reportData = reportData + '\n';
    });
    reportData = reportData.replace(/,\s*$/, "");
    text = text + reportData;
    let element = document.createElement(
      'a'
    );
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    );
    element.setAttribute(
      'download',
      filename
    );
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  render() {
    let deliveredCars = [];
    const {selectedCustomers} = this.state;
    let downloadableCsvDataDelivered = "Job Ref,Reg/VIN,Type of Movement,Collection Address,Collection Postcode,Deliver Address,Deliver Postcode,Status,Delivery Date,Mileage,Unit Price,Invoice Date,Invoice Number";
    let expensesRows = [],expensesCols=[],totalExpenseLength = 0;
    if(this.state.dailyDeliveredCarReportData.length > 0){
        this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
            totalExpenseLength = (currentJob.expense_approvals != null) ? (totalExpenseLength < currentJob.expense_approvals.length) ? currentJob.expense_approvals.length : totalExpenseLength : 0;
        });
    }
    
    /* create expense column dynamic */
    if(totalExpenseLength > 0){
        for(let k=1;k<=totalExpenseLength;k++){
            expensesCols.push(
                <th key={k}>FUEL {k}</th>    
            );
            downloadableCsvDataDelivered = downloadableCsvDataDelivered+','+"FUEL"+k;
        }
    }
    expensesCols.push(
        <th key="unit-cost-fuel">UNIT COST + FUEL</th>
    );   
    downloadableCsvDataDelivered = downloadableCsvDataDelivered+",UNIT COST + FUEL";
     if(this.state.dailyDeliveredCarReportData.length > 0){
        this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
            let mileage = currentJob.distance_in_miles;
            let FuelExpense = 0;
            expensesRows = [];
            if(totalExpenseLength > 0){                
                if((currentJob.expense_approvals != null && currentJob.expense_approvals.length > 0)){
                    currentJob.expense_approvals.map((expense,key)=>{
                        
                        if(expense.client_charge_in_pence != 0){
                            let netAmount = (expense.cost_in_pence/1.2);
                            FuelExpense = FuelExpense + netAmount;

                            netAmount = (netAmount/100).toFixed(2);

                            expensesRows.push(
                                <td key={key}>&pound;{netAmount}</td>
                            );
                        }else{
                            expensesRows.push(
                                <td key={key}>&nbsp;</td>    
                            );
                        }
                        
                    });
                    FuelExpense = FuelExpense / 100;
                    if(expensesRows.length != totalExpenseLength){
                        let remainingCols = (totalExpenseLength) - (expensesRows.length);
                        for(let j=1;j<=remainingCols;j++){
                            expensesRows.push(
                                <td key={"no-expense"+j+currentJob.id}>&nbsp;</td>    
                            );
                        }
                    }
                }
                for(let k=1;k<=totalExpenseLength;k++){
                    
                    if((currentJob.expense_approvals != null && currentJob.expense_approvals.length > 0)){
                        {expensesRows}
                    }else{
                        expensesRows.push(
                            <td key={k}>&nbsp;</td>    
                        );
                    }
                }
            }
            let unitCost = parseFloat(currentJob.job_price) + parseFloat(FuelExpense);
            unitCost = unitCost.toFixed(2);
            expensesRows.push(
                    <td key="Unit-cost-{index}">&pound;{unitCost}</td>
            );
            let joburl = "/jobs/view/"+currentJob.id;
            let movementType = (currentJob.type_of_movement);
            let status = 'DELIVERED';
            let selectedDate = this.state.selected_date;
            if(currentJob != null){
                
                deliveredCars.push(
                      <tr key={index}>
                          <td><a href={joburl}>{currentJob.id}</a></td>
                          <td>
                            {currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}
                          </td>
                          <td className='to-up'>{movementType}</td>
                          <td>
                            {currentJob.pickup_address.address_line_1}
                          </td>
                          <td>
                            {currentJob.pickup_address.postcode}
                          </td>
                          <td>
                            {currentJob.dropoff_address.address_line_1}
                          </td>
                          <td>
                            {currentJob.dropoff_address.postcode}
                          </td>
                          <td>{status}</td>
                          <td>{moment(selectedDate).format("DD.MM.YY")}</td>
                          <td>{mileage}</td>
                          <td>&pound;{currentJob.job_price}</td>
                          <td>{ (currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : ""}</td>
                          <td>{currentJob.invoice_number}</td>
                         {expensesRows}
                      </tr>    
                );
                  
            }
            
        });
    }else{
        deliveredCars.push(
            <tr key='no-records'><td colSpan="14" className='text-center'>No Records</td></tr>
        );
    }
   
    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h2>Daily Delivered Log</h2>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-2 col-sm-12">
                <label><h3>Select Date</h3></label><br/>
                <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleDeliveredDateCalendarChange} selected={this.state.selected_date}/>
          </div>
          <div className="col-md-3 col-sm-12">
            <label><h3>Select Customer</h3></label><br/>
            
                <div>
                     <StatefulMultiSelect
                        options={this.state.customers}
                        selected={selectedCustomers}
                        onSelectedChanged={this.handleCustomerSelection}
                            overrideStrings={{
                                selectSomeItems: "Select Customers...",
                                allItemsAreSelected: "All Customers are Selected",
                                selectAll: "Select All",
                                search: "Search",
                            }}
                        />
                </div>
                
          </div>
          <div className="col-md-2 col-sm-12">
            <button  className="btn btn-lg btn-success daily-delivered-btn-margin" onClick={this.handleDailyDeliveredCarReportGeneration}>
                <i className="fa fa-save"></i> Generate Report
            </button>
          </div>
          <div className="col-md-2 col-sm-12">
            <button className="btn btn-primary btn-lg daily-delivered-btn-margin"
                    onClick={(e) => {
                    this.download("dailyDeliveredCarReport.csv", downloadableCsvDataDelivered);
                  }}>
                <i className="fa fa-download"></i> Download for Spreadsheet
            </button>
          </div>
        </div>
        <div className="row">
            <div className="col-md-12 col-sm-12">
                <div className="daily-delivered-report-tbl-scroll">
                    <table className="daily-delivered-report-tbl">
                        <thead>
                            <tr>
                                <th>Job Ref</th>
                                <th>Reg/VIN</th>
                                <th>Type of Movement</th>
                                <th>Collection Address</th>
                                <th>Collection Postcode</th>
                                <th>Deliver Address</th>
                                <th>Deliver Postcode</th>
                                <th>Status</th>
                                <th>Delivery Date</th>
                                <th>Mileage</th>
                                <th>Unit Price</th>
                                <th>Invoice Date</th>
                                <th>Invoice Number</th>
                                {expensesCols}
                            </tr>
                        </thead>
                        <tbody>

                        {this.state.isLoading ?
                        (<tr><td colSpan="14"><span className="add-loading-text">
                                <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                            deliveredCars
                        }
                        </tbody>
                    </table>
                </div>
                <br/><br/><br/>
            </div>
        </div>
      </div>
    );
  }
}

